import React__default from 'react';
import { Box, FlexBox, Typography, Callout } from '@vp/swan';
import st from '../../../../../../../../../../styled-components/dist/styled-components.esm.mjs';
import { WideQuantityListPrice } from './wide-quantity-list-price.mjs';
import { useProductOptionsTranslations } from '../../../../../product-options-translations/product-option-translations.mjs';
import { Savings } from '../../savings-format.mjs';

const QuantityItemContainer = st.div `
margin-bottom: var(--swan-spacing-standard-4);

container-type: inline-size;

.quantity-container {
    flex-direction: column;
}
  
.quantity-number-callouts {
    width: 200px;
    margin-bottom: var(--swan-sem-space-3);
}

.quantity-prices {
    flex-direction: column;
    flex-grow: 1;
  }

@container (width > 400px) {
  .quantity-container {
    flex-direction: row;
  }

  .quantity-number-callouts {
    width: 150px;
  }

  .quantity-prices {
    flex-direction: column;
    align-items: end;
  }
}

@container (width > 600px) {
  .quantity-container {
    flex-direction: row;
  }

  .quantity-number-callouts {
    width: 200px;
    margin-bottom: 0;
  }

  .quantity-prices {
    flex-direction: row;
    flex-grow: 1;
    align-items: unset;
  }
}

`;
const QuantityItem = ({ choice, priceDisplayMode, locale, currency, fractionDigits, isSampleQuantity, quantitySavingsIsVisible, onSale, savingsFormat, }) => {
    const { i18n } = useProductOptionsTranslations();
    return (React__default.createElement(QuantityItemContainer, null,
        React__default.createElement(Box, null,
            React__default.createElement(FlexBox, { className: "quantity-container", justifyContent: "space-between" },
                React__default.createElement(FlexBox, { className: "quantity-number-callouts", alignItems: "center" },
                    React__default.createElement(Typography, { paddingRight: "3", fontSkin: "body-standard" }, choice.name),
                    React__default.createElement(FlexBox, null, choice.callouts?.map((callout) => {
                        return (React__default.createElement(Callout, { emphasis: "low", key: callout.key, skin: callout.style ?? "accent" }, callout.text));
                    }))),
                React__default.createElement(FlexBox, { className: "quantity-prices", justifyContent: "space-between" },
                    priceDisplayMode !== "none" && (React__default.createElement(WideQuantityListPrice, { choice: choice, locale: locale, fractionDigits: fractionDigits, currency: currency })),
                    isSampleQuantity && (React__default.createElement(FlexBox, { alignItems: "center" },
                        React__default.createElement(Callout, { border: "none", emphasis: "low" }, i18n("sample")))),
                    quantitySavingsIsVisible && (React__default.createElement(FlexBox, { alignItems: "baseline" },
                        React__default.createElement(Savings, { culture: locale, currency: currency, minimumFractionDigits: fractionDigits, savingsFormat: savingsFormat ?? "percent", savingsTotal: choice.savingsTotal, savingsPercent: choice.savingsPercent, onSale: onSale }))))))));
};

export { QuantityItem };
//# sourceMappingURL=quantity-item.mjs.map
